// test481
(481 && 0);
